module.exports = __webpack_public_path__ + "static/img/nothing.0f5907c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/nothing.png
// module id = 156
// module chunks = 107